import { Client } from "./Clients";

export class CupsPriceLevelHeader {
  id!: string;
  externalName!: string;
  state!: string;
  cups!: string;
  clients!: Client;
  name?: string;
  requiredPriorOrder?: boolean;
}
